/**
 * RaceCountdown Component
 *
 * Fullscreen overlay showing 3-2-1 countdown before race starts.
 */

import styles from './Race.module.css';

interface RaceCountdownProps {
  count: number;
}

export function RaceCountdown({ count }: RaceCountdownProps) {
  const displayText = count === 0 ? 'GO!' : count.toString();

  return (
    <div className={styles.countdownOverlay}>
      <div className={styles.countdownContent}>
        <span className={styles.countdownNumber} key={count}>
          {displayText}
        </span>
        <p className={styles.countdownHint}>Get ready!</p>
      </div>
    </div>
  );
}
